import 'core-js/es/array';
import 'core-js/es/symbol';
import React from 'react';
import {createRoot} from 'react-dom/client';
import store from './store';
import './assets/libs/bootstrap.min';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import {loadApiConfig} from "./actions/apiConfigActions";
import MainIndex from './MainIndex';
import {BASE_URL} from './constants';
import {isKioskMode, fetchKioskSession, kioskUserFoundAction} from './utils/kiosk';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <div className="ml-2">Loading...</div>
);

/**
 * Puts a truck console back into the app signed in, before anything renders.
 *
 * The console reloads itself regularly (Main's idle timer, AutoReload) and the reload keeps whatever
 * path it was on. Without this, Main would find no user and redirect to B2C — a sign-in nobody can
 * complete standing at the back of a truck. The session comes from the Pi rather than browser
 * storage, so it survives the reload.
 */
function restoreKioskSession() {
    if (!isKioskMode()) {
        return Promise.resolve();
    }

    return fetchKioskSession().then(session => {
        if (session && session.paired && session.token) {
            store.dispatch(kioskUserFoundAction(session));
            return;
        }

        // Not signed in: the shift token expired, the office force-unpaired, or the driver signed
        // out. Land on the pairing screen instead of B2C.
        if (window.location.pathname !== `${BASE_URL}/kiosk`) {
            window.history.replaceState({}, '', `${BASE_URL}/kiosk`);
        }
    });
}

store.dispatch(loadApiConfig())
  .then(restoreKioskSession)
  .then(() => {
    return root.render(
      store && store.getState() && store.getState().apiConfig && store.getState().apiConfig.authority ?
      <MainIndex />
      :
      <div className="ml-2">Loading...</div>
    );
});


